module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [0, 0],
            [2, 0],
            [2, 2],
            [0, 2],
            [0, 0],
        ]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 0],
            [4, 0],
            [4, 2],
            [2, 2],
            [2, 0],
        ]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 0],
            [6, 0],
            [6, 2],
            [4, 2],
            [4, 0],
        ]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 0],
            [8, 0],
            [8, 2],
            [6, 2],
            [6, 0],
        ]
    },
    'color-5': {
        name: 'Color 5',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 0],
            [10, 0],
            [10, 2],
            [8, 2],
            [8, 0],
        ]
    },
    'color-6': {
        name: 'Color 6',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 0],
            [12, 0],
            [12, 2],
            [10, 2],
            [10, 0],
        ]
    },
    'color-7': {
        name: 'Color 7',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
        
            [0, 2],
            [2, 2],
            [2, 4],
            [0, 4],
            [0, 2],
        ]
    },
    'color-8': {
        name: 'Color 8',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 2],
            [4, 2],
            [4, 4],
            [2, 4],
            [2, 2],
        ]
    },
    'color-9': {
        name: 'Color 9',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 2],
            [6, 2],
            [6, 4],
            [4, 4],
            [4, 2],
        ]
    },
    'color-10': {
        name: 'Color 10',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 2],
            [8, 2],
            [8, 4],
            [6, 4],
            [6, 2],
        ]
    },
    'color-11': {
        name: 'Color 11',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 2],
            [10, 2],
            [10, 4],
            [8, 4],
            [8, 2],
        ]
    },
    'color-12': {
        name: 'Color 12',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 2],
            [12, 2],
            [12, 4],
            [10, 4],
            [10, 2],
        ]
    },
    'color-13': {
        name: 'Color 13',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [0, 4],
            [2, 4],
            [2, 6],
            [0, 6],
            [0, 4],
        ]
    },
    'color-14': {
        name: 'Color 14',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 4],
            [4, 4],
            [4, 6],
            [2, 6],
            [2, 4],
        ]
    },
   
    'color-15': {
        name: 'Color 15',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 4],
            [6, 4],
            [6, 6],
            [4, 6],
            [4, 4],
        ]
    },
    'color-16': {
        name: 'Color 16',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 4],
            [8, 4],
            [8, 6],
            [6, 6],
            [6, 4],
        ]
    },
    'color-17': {
        name: 'Color 17',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 4],
            [10, 4],
            [10, 6],
            [8, 6],
            [8, 4],
        ]
    },
    'color-18': {
        name: 'Color 18',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 4],
            [12, 4],
            [12, 6],
            [10, 6],
            [10, 4],
        ]
    },
    'color-19': {
        name: 'Color 19',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [0, 6],
            [2, 6],
            [2, 8],
            [0, 8],
            [0, 6],
            [0, 0],
        ]
    },
    
    
    'color-20': {
        name: 'Color 20',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 6],
            [4, 6],
            [4, 8],
            [2, 8],
            [2, 6],
        ]
    },
    'color-21': {
        name: 'Color 21',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 6],
            [6, 6],
            [6, 8],
            [4, 8],
            [4, 6],
        ]
    },
    
    'color-22': {
        name: 'Color 22',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 6],
            [8, 6],
            [8, 8],
            [6, 8],
            [6, 6],
        ]
    },
    'color-23': {
        name: 'Color 23',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 6],
            [10, 6],
            [10, 8],
            [8, 8],
            [8, 6],
        ]
    },
    'color-24': {
        name: 'Color 24',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 6],
            [12, 6],
            [12, 8],
            [10, 8],
            [10, 6],
        ]
    },
    'color-25': {
        name: 'Color 25',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [0, 8],
            [2, 8],
            [2, 10],
            [0, 10],
            [0, 8],
        ]
    },
    'color-26': {
        name: 'Color 26',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 8],
            [4, 8],
            [4, 10],
            [2, 10],
            [2, 8],
        ]
    },
    'color-27': {
        name: 'Color 27',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 8],
            [6, 8],
            [6, 10],
            [4, 10],
            [4, 8],
        ]
    },
    'color-28': {
        name: 'Color 28',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 8],
            [8, 8],
            [8, 10],
            [6, 10],
            [6, 8],
        ]
    },
    'color-29': {
        name: 'Color 29',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 8],
            [10, 8],
            [10, 10],
            [8, 10],
            [8, 8],
        ]
    },
    'color-30': {
        name: 'Color 30',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 8],
            [12, 8],
            [12, 10],
            [10, 10],
            [10, 8],
        ]
    },
    'color-31': {
        name: 'Color 31',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [0, 10],
            [2, 10],
            [2, 12],
            [0, 12],
            [0, 10],
        ]
    },
    'color-32': {
        name: 'Color 32',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [2, 10],
            [4, 10],
            [4, 12],
            [2, 12],
            [2, 10],
        ]
    },
    'color-33': {
        name: 'Color 33',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [4, 10],
            [6, 10],
            [6, 12],
            [4, 12],
            [4, 10],
        ]
    },
    'color-34': {
        name: 'Color 34',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [6, 10],
            [8, 10],
            [8, 12],
            [6, 12],
            [6, 10],
        ]
    },
    'color-35': {
        name: 'Color 35',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [8, 10],
            [10, 10],
            [10, 12],
            [8, 12],
            [8, 10],
        ]
    },
    
    'color-36': {
        name: 'Color 36',
        fillAll: true,
        placeholderColor: 'rgb(255, 255, 255)',
        border: [
            [10, 10],
            [12, 10],
            [12, 12],
            [10, 12],
            [10, 10],
        ]
    },


}



// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/mosaik-custom.js